export const environment = {
  production: true,
  debugLevel: 0,
  lang: 'de_DE',
  country: 'de'

};
